export default {
  nav: {
    home: 'Home',
    products: 'Products',
    about: 'About Us',
    contact: 'Contact'
  },
  header: {
    searchPlaceholder: 'Search products...',
    contactSupplier: 'Contact Supplier',
    language: 'Language'
  },
  home: {
    categories: 'Product Categories',
    categoriesSub: 'Explore our wide range of packaging solutions',
    products: 'Products',
    whyChooseUs: 'Why Choose Us',
    contactTitle: 'Contact us to get more information!',
    contactSub: 'Professional packaging solutions customized for your brand',
    chatNow: 'Chat Now',
    companyIntro: 'Company Introduction',
    productionProcess: 'Production Process',
    learnMore: 'Learn More',
    reasonEquipment: 'Advanced Production Equipment',
    reasonTeam: 'Experienced Packaging Team',
    reasonQuality: 'Strict Quality Control',
    reasonSample: 'Fast Sample Production',
    reasonDelivery: 'Reliable On-Time Delivery'
  },
  products: {
    allProducts: 'All Products',
    categories: 'Categories',
    searchPlaceholder: 'Search products...',
    sortBy: 'Sort by',
    sortDefault: 'Default',
    sortName: 'Name A-Z',
    noProducts: 'No products found',
    moq: 'MOQ',
    inquiryNow: 'Inquiry Now',
    details: 'Details'
  },
  productDetail: {
    description: 'Description',
    specifications: 'Specifications',
    productDetails: 'Product Details',
    sendInquiry: 'Send Inquiry',
    chatNow: 'Chat Now',
    relatedProducts: 'Related Products',
    productNotFound: 'Product not found',
    backToProducts: 'Back to Products'
  },
  about: {
    mainProducts: 'Main Products',
    certifications: 'Certifications',
    ourFactory: 'Our Factory',
    factoryPrefix: 'Factory',
    contactTitle: 'Contact us to get more information!',
    contactSub: 'Professional packaging solutions customized for your brand',
    companyIntro: 'Company Introduction',
    productionProcess: 'Production Process'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in touch with us for any inquiries about our products and services',
    sendInquiry: 'Send Inquiry',
    contactInfo: 'Contact Information',
    name: 'Your Name',
    namePlaceholder: 'Enter your name',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    phone: 'Phone',
    phonePlaceholder: 'Enter your phone number',
    company: 'Company',
    companyPlaceholder: 'Enter your company name',
    productInterest: 'Product Interest',
    productPlaceholder: 'Select product category',
    message: 'Message',
    messagePlaceholder: 'Please describe your requirements in detail...',
    send: 'Send Inquiry',
    reset: 'Reset',
    address: 'Address',
    fax: 'Fax',
    mapSoon: 'Map will be available soon',
    success: 'Inquiry sent successfully! We will get back to you soon.',
    nameRequired: 'Please enter your name',
    emailRequired: 'Please enter your email',
    emailInvalid: 'Please enter a valid email',
    messageRequired: 'Please enter your message'
  },
  footer: {
    aboutUs: 'About Us',
    aboutText: 'Dongguan Caicheng Printing Factory is a professional packaging manufacturer with 21 years of experience, specializing in paper boxes, gift boxes, paper bags, and more.',
    products: 'Products',
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Info',
    location: 'Dongguan City, Guangdong Province, China',
    allRightsReserved: 'All Rights Reserved'
  },
  floating: {
    contact: 'Contact',
    chat: 'Chat',
    top: 'Top'
  },
  categories: {
    mailerBox: 'Mailer Box',
    magneticGiftBox: 'Magnetic Gift Box',
    drawerBox: 'Drawer Box',
    paperBag: 'Paper Bag',
    paperCard: 'Paper Card',
    catalogue: 'Catalogue'
  }
}
